import React from 'react';
import { BrandLogo } from './BrandLogo';

interface FooterProps {
  onNavigate: (route: string) => void;
}

export const Footer: React.FC<FooterProps> = ({ onNavigate }) => {
  return (
    <footer id="main_footer" className="w-full border-t border-slate-200/80 bg-white/70 backdrop-blur-md pt-12 pb-16 mt-20 text-slate-500 text-xs">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-5 gap-8 pb-10">
        {/* Col 1 Brand */}
        <div className="md:col-span-2 space-y-3">
          <BrandLogo onClick={() => onNavigate('/')} size="sm" />
          <p className="text-slate-500 text-xs leading-relaxed max-w-sm">
            App intelligence and market radar for mobile apps, rankings, growth, competitors, and breakout opportunities across the global app economy.
          </p>
          <div className="text-[11px] text-slate-400">
            * All download and revenue metrics are estimated models for research intelligence. Public app metadata is fetched directly from Apple.
          </div>
        </div>

        {/* Col 2 Intelligence */}
        <div className="space-y-2.5">
          <h4 className="font-bold text-slate-900 uppercase tracking-wider text-[10px]">Intelligence</h4>
          <ul className="space-y-1.5">
            <li><button onClick={() => onNavigate('/trending')} className="hover:text-slate-900 transition-colors">Trending & Breakouts</button></li>
            <li><button onClick={() => onNavigate('/charts')} className="hover:text-slate-900 transition-colors">Top Charts (US & Global)</button></li>
            <li><button onClick={() => onNavigate('/ai-insights')} className="hover:text-slate-900 transition-colors">AI Market Insights</button></li>
            <li><button onClick={() => onNavigate('/compare')} className="hover:text-slate-900 transition-colors">App Comparison</button></li>
          </ul>
        </div>

        {/* Col 3 Directory */}
        <div className="space-y-2.5">
          <h4 className="font-bold text-slate-900 uppercase tracking-wider text-[10px]">Directory</h4>
          <ul className="space-y-1.5">
            <li><button onClick={() => onNavigate('/apps')} className="hover:text-slate-900 transition-colors">All Applications</button></li>
            <li><button onClick={() => onNavigate('/developers')} className="hover:text-slate-900 transition-colors">Developer Profiles</button></li>
            <li><button onClick={() => onNavigate('/keywords')} className="hover:text-slate-900 transition-colors">Keyword Radar</button></li>
            <li><button onClick={() => onNavigate('/collections')} className="hover:text-slate-900 transition-colors">App Collections</button></li>
          </ul>
        </div>

        {/* Col 4 Diagnostics & Tools */}
        <div className="space-y-2.5">
          <h4 className="font-bold text-slate-900 uppercase tracking-wider text-[10px]">Platform & Diagnostics</h4>
          <ul className="space-y-1.5">
            <li><button onClick={() => onNavigate('/pricing')} className="hover:text-slate-900 transition-colors">Pricing & Plans</button></li>
            <li><button onClick={() => onNavigate('/watchlist')} className="hover:text-slate-900 transition-colors">My Watchlist</button></li>
            <li>
              <button
                onClick={() => onNavigate('/admin/data-quality')}
                className="hover:text-emerald-700 transition-colors flex items-center gap-1 font-semibold text-emerald-600"
              >
                <span>Data Trust & Quality Monitor</span> ↗
              </button>
            </li>
            <li>
              <button
                onClick={() => onNavigate('/debug/catalog')}
                className="hover:text-slate-900 transition-colors flex items-center gap-1"
              >
                <span>Catalog Telemetry & Ingestion</span> ↗
              </button>
            </li>
            <li>
              <button
                onClick={() => onNavigate('/debug-icons')}
                className="hover:text-blue-600 transition-colors flex items-center gap-1 font-semibold text-blue-600"
              >
                <span>Artwork Diagnostics</span> ↗
              </button>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="max-w-7xl mx-auto px-6 pt-6 border-t border-slate-100 flex flex-col sm:flex-row items-center justify-between gap-4 text-[11px] text-slate-400">
        <span>© 2026 AppStatsView. Global App Store Discovery Platform.</span>
        <div className="flex gap-6">
          <button onClick={() => onNavigate('/pricing')} className="hover:text-slate-600">Plans</button>
          <button onClick={() => onNavigate('/apps')} className="hover:text-slate-600">Database</button>
          <button onClick={() => onNavigate('/debug/catalog')} className="hover:text-slate-600">Diagnostics</button>
        </div>
        <span>App Store is a trademark of Apple Inc. Google Play is a trademark of Google LLC.</span>
      </div>
    </footer>
  );
};
